import { render, staticRenderFns } from "./RegisterView.vue?vue&type=template&id=4c766e65&"
import script from "./RegisterView.vue?vue&type=script&lang=ts&"
export * from "./RegisterView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports